import axios from "axios";
import { z } from "zod";
import { toast } from "../../components/ui/use-toast";
import { hashPasswordForTransport, createTimestamp, SecureAuthData } from "../../utils/cryptoUtils";
const baseURL = process.env.REACT_APP_SERVER_URL;

export const handleSignUp = async (
  formData: any,
  setFormData: Function,
  UserSignUpSchema: any,
  navigate: Function
) => {
  try {
    UserSignUpSchema.parse(formData);
    const response = await axios.post(`${baseURL}/api/auth/signup`, formData);
    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: "User created ...",
      className: "bg-green-500 border border-green-500",
    });
    navigate("/admin-dashboard/utilisateurs");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const handleLogin = async (
  formData: any,
  setFormData: Function,
  UserLoginSchema: any,
  navigate: Function
) => {
  try {
    UserLoginSchema.parse(formData);

    // Authentification standard sans timestamp
    const loginData = {
      email: formData.email,
      password: formData.password
    };

    const response = await axios.post(`${baseURL}/api/auth/login`, loginData);
    localStorage.setItem("token", response.data.user.token);
    const role = response.data.user.user.role;

    if (role === "ADMIN") {
      navigate("/admin-dashboard");
    }
    toast({
      variant: "destructive",
      title: " Connexion réussie",
      description: "Bienvenue ...",
      className: "bg-green-500 border border-green-500",
    });
    setFormData({ email: "", password: "" });
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const handleLogout = async () => {
  localStorage.removeItem("token");
  await new Promise((resolve) => setTimeout(resolve, 100));
  window.location.href = "/";
};
